// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"350c3668","2569":"5563e0ef","3125":"24648a0f","5343":"350c3668","7939":"24648a0f","9341":"c5197946"}[chunkId] + ".chunk.css";
};